(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ITEM_SELECTOR = [
    '.card-wrapper',
    '.product-card',
    '.grid__item',
    '.mlfa-series-item',
    '.mlfa-carousel-item',
    '.mlfa-statement',
    '.mlfa-berky-item',
    'img'
  ].join(', ');

  function init() {
    var main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mlfa-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    var sections = main.querySelectorAll('.shopify-section');

    sections.forEach(function (section) {
      section.classList.add('mlfa-reveal');
      observer.observe(section);

      var items = section.querySelectorAll(ITEM_SELECTOR);
      var seen = new Set();
      var index = 0;

      items.forEach(function (item) {
        if (item.closest('.mlfa-reveal') !== section) return;
        if (seen.has(item)) return;
        seen.add(item);

        item.classList.add('mlfa-reveal');
        item.style.setProperty('--mlfa-delay', (index % 8) * 70 + 'ms');
        observer.observe(item);
        index++;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
